import { NotificationStoreState } from './state';

import { NOTIFICATIONS, NOTIFICATIONS_ERROR, DELETE_NOTIFICATION, UPDATE_NOTIFICATION, CLEAR_NOTIFICATION } from './types';

export default function notification(state = NotificationStoreState, action: any) {

  switch (action.type) {
    case NOTIFICATIONS:

      return [
        ...action.payload
      ]


    case NOTIFICATIONS_ERROR:
      return [
        ...state,
        ...action.payload
      ];

    case DELETE_NOTIFICATION:
         let newStates = Object.assign({}, state);
         if (state.length) {
           newStates = state.filter((item: any) => {
             if (item.id !== action.payload.id) {
               return item;
             }
           });
         // newStates.splice(indexCourseDelete, 1);
         }

       return newStates;

    case UPDATE_NOTIFICATION:
      let newState = Object.assign({}, state);
      if (state.length) {
        newState = state.filter((item: any) => {
          if (item.id !== action.payload.id) {
            return item;
          }
        });
      // newState.splice(indexCourseDelete, 1);
      }
    return newState;

    case CLEAR_NOTIFICATION:
      return []
    
    default:
      return state;
  }
}
